import { ROUTES } from '#/config/routes';
import {
  getMaterialSnapshotMtrId,
  getMaterialSnapshotMtrNo,
} from '#/modules/crmMgmt/customerOrder/helper/mapCustomerOrderMeta';
import {
  formatMaterialSnapshotRequiredQtyForQuery,
  resolveMaterialSnapshotRequiredQty,
} from '#/modules/crmMgmt/customerOrder/helper/resolveMaterialSnapshotRequiredQty';

/**
 * 客訂 line 物料快照 → 工單建立頁 deep link（Phase 0：query prefill）。
 * 禁止用 line.product；製造量 = (orderQty − cancelQty) × qtyPerProduct。
 * 讀 mtr.{id,mtrNo}／qtySummary 優先，fallback 舊扁平。
 */
export function buildWorkOrderCreateUrlFromMaterialSnapshot(line, material) {
  const params = new URLSearchParams();

  const manufacturingQty = formatMaterialSnapshotRequiredQtyForQuery(
    resolveMaterialSnapshotRequiredQty(line, material),
  );
  if (manufacturingQty) {
    params.set('manufacturing_qty', manufacturingQty);
  }

  const mtrId = getMaterialSnapshotMtrId(material);
  const mtrNo = getMaterialSnapshotMtrNo(material);

  if (mtrId) {
    params.set('mtr_id', String(mtrId));
  } else if (mtrNo) {
    params.set('mtr_no', String(mtrNo));
  }

  const query = params.toString();
  return query ? `${ROUTES.workOrderCreate}?${query}` : ROUTES.workOrderCreate;
}
